import { DepreciationSettingsV2JSON, PairedCostSettingsJSON } from '@aloft/toolkit-shared';
import { createAction } from '@reduxjs/toolkit';

export const setSettings =
  createAction<Partial<PairedCostSettingsJSON & DepreciationSettingsV2JSON & {
    costMultiplier?: number;
  }>>('setSettings');
